<template>
	<div>
		<v-tooltip v-if="asIcon" right>
			<template v-slot:activator="{ props }">
				<v-icon v-bind="props">mdi-source-branch</v-icon>
			</template>
			<span>{{ version }}</span>
		</v-tooltip>
		<span v-if="typeof version === 'string' && !asIcon" class="text-body-2 font-weight-light">{{ version }}</span>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
	name: 'Version',
	props: {
		asIcon: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	computed: {
		...mapState({
			version: (state) => state.version.version,
		}),
	},
	methods: {
		...mapActions({
			loadVersion: 'version/loadVersion',
		}),
	},
	mounted: async function () {
		await this.loadVersion();
	},
};
</script>
